import { Field, TAnswer } from "src/shared/contexts/HackerContext/types";
import {
  RBCImg,
  FederatoImg,
  ShopifyImg,
  DominionDynamicsImg,
  BrowserbaseImg,
  BlackberryQnxImg,
  CitadelImg,
  CognitionImg,
  ComposioImg,
  ConvexImg,
  GoogleImg,
  GptZeroImg,
  HrtImg,
  IntactImg,
  LogitechImg,
  MetaImg,
  NeticImg,
  OmenImg,
  PhoebeImg,
  RillaImg,
  RoxImg,
  RundooImg,
  SentryImg,
  SolanaImg,
  SunlifeImg,
  TdImg,
  TetherImg,
  VirtuImg,
} from "src/static/img";

export const ACCEPTED_FIELDS = [
  Field.RECRUITMENT_CONSENT,
  Field.RESUME,
  Field.SPONSOR_INTEREST,
  Field.COFFEE_CHAT,
  Field.CAREER_RSVP_STAGE,
  Field.EVENT_RSVP_STAGE,
];

export const VALIDATORS: Partial<Record<Field, (value: TAnswer) => boolean>> =
  {}; // no validation needed - they can leave all fields on this page empty if they want

// `id` must match `companies.name` in hackerapi exactly — the sponsor
// recruitment tool joins hacker interest to a sponsor by comparing these
// strings. `label` overrides what hackers see when the legal name reads badly.
export type TSponsorOption = { id: string; label?: string; logo: any };

export const GOLD_SPONSORS: TSponsorOption[] = [
  { id: "RBC", logo: RBCImg },
  { id: "Federato", logo: FederatoImg },
  { id: "Shopify", logo: ShopifyImg },
  { id: "Dominion Dynamics", logo: DominionDynamicsImg },
];

const SILVER_SPONSORS: TSponsorOption[] = [
  { id: "Logitech", logo: LogitechImg },
  { id: "Convex", logo: ConvexImg },
  { id: "TD", logo: TdImg },
  { id: "Sentry", logo: SentryImg },
  { id: "Hudson River Trading", label: "HRT", logo: HrtImg },
  { id: "Solana", logo: SolanaImg },
  { id: "Cybernetic Labs", label: "Netic", logo: NeticImg },
  { id: "Browserbase", logo: BrowserbaseImg },
  { id: "Intact", logo: IntactImg },
  { id: "Citadel", logo: CitadelImg },
  { id: "Tether", logo: TetherImg },
  { id: "Rox", logo: RoxImg },
  { id: "GPTZero", logo: GptZeroImg },
  { id: "Google", logo: GoogleImg },
  { id: "Sun Life", logo: SunlifeImg },
  { id: "QNX", logo: BlackberryQnxImg },
  { id: "Rundoo Inc", label: "Rundoo", logo: RundooImg },
  { id: "OMEN ANALYTICS INC", label: "Omen", logo: OmenImg },
  { id: "Virtu Financial", label: "Virtu", logo: VirtuImg },
  { id: "Phoebe", logo: PhoebeImg },
  { id: "Composio", logo: ComposioImg },
  { id: "Rilla", logo: RillaImg },
  { id: "Cognition", logo: CognitionImg },
  { id: "Meta", logo: MetaImg },
];

export const COMPANY_INTEREST_OPTIONS = GOLD_SPONSORS.concat(SILVER_SPONSORS);

export const COFFEE_CHAT_OPTIONS = GOLD_SPONSORS;
